import * as _ from 'lodash';
import { Component, Input } from '@angular/core';

import { Kb } from '@models';
import { ServiceKb } from '@services';

@Component({
    selector: 'kb-needs-token',
    templateUrl: './kb-needs-token.component.html',
    styleUrls: ['./kb-needs-token.component.scss']
})
export class KbNeedsTokenComponent {
    @Input() showText?: boolean = false;
    @Input() showIcon?: boolean = true;

    private _kb: Kb;
    @Input()
    set kb(value: Kb) {
        this._kb = value;
        this._setAttributes();
    }
    get kb(): Kb {
        return this._kb;
    }

    private _editionMode: boolean;
    @Input()
    set editionMode(value: boolean) {
        this._editionMode = value;
    }
    get editionMode(): boolean {
        return this._editionMode;
    }

    public icon: string = 'fas fa-question';
    public class: string = '';
    public tooltip: string = 'KB.NEEDS_TOKEN.ICON.NO_INFO';

    constructor(
        private serviceKb: ServiceKb
    ) { }

    onSlide($event) {
        this._kb.needsToken = $event.checked;
        this.serviceKb.kb = this._kb;
    }

    private _setAttributes() {
        const value = this._kb.needsToken;
        if (value === false) {
            this.icon = 'fas fa-tint-slash';
            this.class = 'no-needs';
            this.tooltip = 'KB.NEEDS_TOKEN.ICON.NO_TOKEN_NEEDED';
        }
        else if (_.get(this, 'kb.isAdmin') === true) {
            this.icon = 'fas fa-tint';
            this.class = 'no-needs-admin';
            this.tooltip = 'KB.NEEDS_TOKEN.ICON.TOKEN_NEEDED_BUT_ADMIN';
        }
        else if (value === true) {
            this.icon = 'fas fa-tint';
            this.class = 'needs';
            this.tooltip = 'KB.NEEDS_TOKEN.ICON.TOKEN_NEEDED';
        }
    }
}
